import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { AnalyseParticulier } from '../model/analyse-particulier';

@Injectable({
    providedIn: 'root'
  })
  export class AnalyseParticulierService {
  
    constructor(private _restClientService : RestClientService) 
    { }

    getAnalyseParticulierByrequestId(requestId){
        
        return this._restClientService.load<AnalyseParticulier>('analyse-particulier/get-by-request?requestid=' + requestId);
    }
    
}